import React, { forwardRef } from "react";
import { Divider, List, Space, Typography } from "antd";
import {
  CommentResponseInput,
  CommentResponseInputHandle,
} from "./CommentResponseInput";
import { useNoteResponse } from "./hooks/useNoteResponse";

interface ImportantCommentsProps {
  comments: string | null;
  soNo: string;
  versionLabel?: string;
  onNoteAdded: () => void;
  allowUpdates?: boolean;
}

export const ImportantComments = forwardRef<
  CommentResponseInputHandle,
  ImportantCommentsProps
>(({ comments, soNo, versionLabel, onNoteAdded, allowUpdates }, ref) => {
  const { submitting, error, submitNote } = useNoteResponse(
    soNo,
    onNoteAdded,
    versionLabel,
  );

  const trimmed = comments?.trim() ?? "";

  return (
    <>
      <Divider orientation="left">Important Comments</Divider>
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        {trimmed ? (
          <List
            dataSource={[trimmed]}
            renderItem={(text) => (
              <List.Item style={{ alignItems: "flex-start" }}>
                <Typography.Text style={{ whiteSpace: "pre-line" }}>
                  {text}
                </Typography.Text>
              </List.Item>
            )}
          />
        ) : (
          <Typography.Text type="secondary">No notes on file</Typography.Text>
        )}
        {allowUpdates && (
          <CommentResponseInput
            ref={ref}
            onSubmit={submitNote}
            submitting={submitting}
            error={error}
          />
        )}
      </Space>
    </>
  );
});
